module.exports = __webpack_public_path__ + "img/icon_fire.5e97080f.png";